exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".riskQuestForm{font-weight:bold;border-radius:1px solid var(--dimGray)}.riskQuestForm__heading,.riskQuestForm__labels,.riskQuestForm__inputs{padding:10px 0}.riskQuestForm__heading{padding:10px 0;background-color:#dbe3f0}.riskQuestForm__labels{padding:10px 0;background-color:#ededef}.riskQuestForm__inputs>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.riskQuestForm input,.riskQuestForm select{width:180px;padding:5px}@media (max-width: 768px){.riskQuestForm .mb-2{margin-bottom:10px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Form/Form.style.scss
// module id = 1649
// module chunks = 0